import React from "react";

const Container = ({ children }) => {
  return <div className="root-container">{children}</div>;
};

export default Container;
